import useTranslation from 'next-translate/useTranslation'
import { workingTimes } from 'tennders-stracture/libs/utils'
import GHref from 'tennders-market/common/components/element/GHref'
import { RouteType } from 'tennders-common/types/RouteType'
import Location from 'tennders-common/form/components/new-inputs/Location'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import { MultipleDatePicker, InputLabeledContainer, TimePicker, NumberInput, TextArea, TextInput } from './index'
import IconDeleteRound from '../../../../icons/icon-delete-round-f.svg'

type Props = {
  index ?: number,
  hasRemoveStop ?: boolean,
  route ?: RouteType,
  truck ?: boolean,
  removeStop ?: (identifier: string) => void,
  onChange ?: any,
  errors ?: Record<string, any>,
  minDate ?: Date | string,
  maxDate ?: Date | string,
  title ?: string,
  forDocument ?: boolean,
  keyPrefix ?: string,
  isAllRequired ?: boolean,
  requiredInputs ?: [],
  orderGenerateDoc?: boolean,
  isDelivery?:boolean
}

const GRoute = (props : Props) => {
  const {
    hasRemoveStop,
    route,
    removeStop,
    onChange,
    errors,
    truck,
    minDate,
    maxDate,
    title,
    forDocument,
    isAllRequired,
    requiredInputs,
    orderGenerateDoc,
    isDelivery
  } = props
  const defaultTimes = workingTimes()
  const { t } = useTranslation()

  return (
    <>
      {title && <h4><strong>{title}</strong></h4>}
      <div className="d-flex row align-end mb-10">
        <InputLabeledContainer
          errors={errors}
          form={route}
          className="mr-10 mb-10"
          label={t(`route:${isDelivery ? 'deliveryLocation' : 'location'}`)}
          name="location"
          required={isAllRequired || (requiredInputs ? String(requiredInputs).includes('location') : false)}
          onChange={(k, v) => onChange({ ...route, location: v }, 'location')}
          renderInput={(rest) => (
            <Location
              isSmartLocation
              asInput
              placeholder={t('route:countryZipCode')}
              {...rest}
            />
          )}
        />
        <div className="mr-10 mb-10" style={{ minWidth: 200 }}>
          <InputLabeledContainer
            name="date"
            form={route}
            errors={errors}
            label={t(`route:${isDelivery ? 'deliveryDate' : 'date'}`)}
            onChange={(name, val) => onChange({ ...route, [name]: val }, 'date')}
            required={isAllRequired || (requiredInputs ? String(requiredInputs).includes('location') : false)}
            renderInput={(rest) => (
              <MultipleDatePicker
                minDate={minDate ? (typeof minDate === 'string' ? new Date(minDate) : minDate) : null}
                maxDate={maxDate}
                {...rest}
              />
            )}
          />
        </div>
        {!truck && (
          <>
            <div className="mr-10 mb-10" style={{ width: 110 }}>
              <InputLabeledContainer
                name="timeFirst"
                label={t('route:avaliableFrom')}
                form={route}
                errors={errors}
                onChange={(name, val) => onChange({ ...route, [name]: val }, 'timeFirst')}
                required={isAllRequired}
                renderInput={(rest) => (
                  <TimePicker
                    initialValue={(route && route.timeFirst && new Date(route.timeFirst)) || defaultTimes[0]}
                    {...rest}
                  />
                )}
              />
            </div>
            <div className="mb-10" style={{ width: 110 }}>
              <InputLabeledContainer
                name="timeSecond"
                label={t('route:to')}
                form={route}
                errors={errors}
                onChange={(name, val) => onChange({ ...route, [name]: val }, 'timeSecond')}
                required={isAllRequired}
                renderInput={(rest) => (
                  <TimePicker
                    initialValue={(route && route.timeSecond && new Date(route.timeSecond)) || defaultTimes[1]}
                    {...rest}
                  />
                )}
              />
            </div>
          </>
        )}
      </div>
      {orderGenerateDoc && (
        <InputLabeledContainer
          name="company"
          label={t('route:companyBuildingName')}
          form={route?.details}
          errors={errors}
          required
          onChange={(name, val) => onChange({ ...route, details: { [name]: val } }, 'company')}
          renderInput={(rest) => (
            <TextInput
              className="form-input w-100"
              placeholder={t('document:building_id')}
              {...rest}
            />
          )}
        />
      )}
      <div className="d-flex row mt-8">
        {(
          truck
            ? (
              <>
                <div className="mr-10 mb-10" style={{ width: 170 }}>
                  <InputLabeledContainer
                    name="freePickupKm"
                    label={t('route:freePickupKm')}
                    form={route}
                    errors={errors}
                    onChange={(name, val) => onChange({ ...route, [name]: val }, 'freePickupKm')}
                    renderInput={(rest) => (
                      <NumberInput
                        placeholder="Kilometers"
                        allowDecimal
                        {...rest}
                      />
                    )}
                  />
                </div>
                <div className="mr-10 mb-10" style={{ width: 150 }}>
                  <InputLabeledContainer
                    name="timeFirst"
                    label={t('route:avaliableFrom')}
                    form={route}
                    errors={errors}
                    onChange={(name, val) => onChange({ ...route, [name]: val }, 'timeFirst')}
                    renderInput={(rest) => (
                      <TimePicker
                        initialValue={(route && route.timeFirst && new Date(route.timeFirst)) || defaultTimes[0]}
                        {...rest}
                      />
                    )}
                  />
                </div>
                <div className="mb-10" style={{ width: 100 }}>
                  <InputLabeledContainer
                    name="timeSecond"
                    label={t('route:to')}
                    form={route}
                    errors={errors}
                    onChange={(name, val) => onChange({ ...route, [name]: val }, 'timeSecond')}
                    renderInput={(rest) => (
                      <TimePicker
                        initialValue={(route && route.timeSecond && new Date(route.timeSecond)) || defaultTimes[1]}
                        {...rest}
                      />
                    )}
                  />
                </div>
              </>
            )
            : (
              <>
                <InputLabeledContainer
                  name="address"
                  className="col-1-2 mb-10"
                  form={route}
                  errors={errors}
                  label={forDocument ? `${t('route:address')}` : `${t('route:address')} (${t('route:optional')})`}
                  onChange={(name, val) => onChange({ ...route, [name]: val }, 'address')}
                  required={isAllRequired}
                  renderInput={(rest) => (
                    <TextArea
                      rows={3}
                      placeholder={t('route:fullAddress')}
                      {...rest}
                    />
                  )}
                />
                <InputLabeledContainer
                  name="instructions"
                  className="col-2-2 mb-10"
                  form={route}
                  label={orderGenerateDoc ? t(`route:${isDelivery ? 'un' : ''}loadingReferenceNotes`) : `${t('route:instructions')} (${t('route:optional')})`}
                  onChange={(name, val) => onChange({ ...route, [name]: val }, 'instructions')}
                  renderInput={(rest) => (
                    <TextArea
                      rows={3}
                      placeholder={t(`route:${isDelivery ? 'deliveryInstructions' : 'pickup_instructions'}`)}
                      maxLength={INPUT_CHARACTER_LIMITS.ADDITIONAL_INFO}
                      {...rest}
                    />
                  )}
                />
              </>
            )
        )}
        {hasRemoveStop && (
          <div className="d-flex align-center mt-16 mr-32 btn-link">
            <GHref className="d-flex align-center" onClick={() => removeStop(route.identifier as string)}>
              <IconDeleteRound className="btn-only-icon" />
              {t('route:removeThisLocation')}
            </GHref>
          </div>
        )}
      </div>
      {!truck && <div className="hr" />}
    </>
  )
}

export default GRoute
